import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { APP_CONTENT_QUERY_KEYS } from '@/lib/constants/appContent';
import { AppContentApi } from './AppContentApi';

/**
 * Fetches the full positions hierarchy for the customer.
 * Used to derive child counts and ordered children at all levels.
 */
export function useAppContentPositions() {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: APP_CONTENT_QUERY_KEYS.positions(selectedCId ?? 0),
    queryFn: () => AppContentApi.getPositions(selectedCId!),
    enabled: selectedCId != null,
    staleTime: 2 * 60_000,
  });
}

/**
 * Fetches positions subtree for a specific root (Content Group).
 * Returns a single ListlistOrderedNode.
 */
export function useAppContentPositionsByRoot(rootLlId: number) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: APP_CONTENT_QUERY_KEYS.positionsByRoot(selectedCId ?? 0, rootLlId),
    queryFn: () => AppContentApi.getPositionsByRoot(selectedCId!, rootLlId),
    enabled: selectedCId != null && rootLlId > 0,
    staleTime: 2 * 60_000,
  });
}
